import { SITE_URL } from '@geosport/shared';
import { routeMeta, type RouteMeta } from '../seo/routes';

function setMeta(attr: 'name' | 'property', key: string, value: string): void {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.content = value;
}

/**
 * Updates the head for an in-app navigation, matching what the build prerendered for that route
 * (title, description, robots, canonical, Open Graph), so tabs, shares and analytics page titles
 * are right however the visitor arrived.
 */
export function applyRouteMeta(path: string): RouteMeta {
  const meta = routeMeta(path);
  const url = `${SITE_URL}${meta.path}`;
  document.title = meta.title;
  setMeta('name', 'description', meta.description);
  setMeta(
    'name',
    'robots',
    meta.noindex ? 'noindex' : 'index, follow, max-image-preview:large, max-snippet:-1',
  );
  setMeta('property', 'og:title', meta.title);
  setMeta('property', 'og:description', meta.description);
  setMeta('property', 'og:url', url);
  let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (meta.noindex) {
    canonical?.remove();
  } else {
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = url;
  }
  return meta;
}
